module.exports = __webpack_public_path__ + "img/icon_7.4267fbcd.png";